/* Legeldle – Akciós sáv és ajándék-widget (sections/legeldle-akcio-sav.liquid).
   - A konfigurációt a szekció <script type="application/json" data-lgd-akciosav-config> adja.
   - A haladássávot a [data-lgd-akciosav="fiok|oldal|panel"] pontokba rajzolja.
   - A kosár változását figyeli: minden /cart/add|change|update|clear hívás után újraolvassa
     a /cart.js-t (a végösszeg a kedvezmények UTÁNI érték), és újrarajzol.
   - Kosár-fiók: a téma a fiók tartalmát újrarendereli (innerHTML), ezért figyeljük, ha a
     beépítési pont üresen újra megjelenik. */
(function () {
  'use strict';

  var IKONOK = {
    ajandek: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 8.5h17v4h-17zM5 12.5h14V20H5zM12 8.5V20"/><path d="M12 8.5c-1.5-3-4.5-4-5.5-2.5S8 8.5 12 8.5zm0 0c1.5-3 4.5-4 5.5-2.5S16 8.5 12 8.5z"/></svg>',
    teherauto: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h10v9H3zM13 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.8" fill="currentColor" stroke="none"/><circle cx="17" cy="17.5" r="1.8" fill="currentColor" stroke="none"/></svg>',
    szazalek: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M19 5L5 19"/><circle cx="7.5" cy="7.5" r="2.5"/><circle cx="16.5" cy="16.5" r="2.5"/></svg>',
    csillag: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.8l2.8 5.9 6.4.8-4.7 4.4 1.2 6.3L12 17.1l-5.7 3.1 1.2-6.3L2.8 9.5l6.4-.8z"/></svg>',
    pipa: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>'
  };

  var cfg = null;          // aktuális konfiguráció
  var kosar = { total: 0, subtotal: 0, darab: 0, ajandekSorok: {} };
  var ajandekFolyamatban = false;  // éppen fut egy ajándék kosárba tétel/kivétel
  var ajandekSikertelen = {};      // küszöb-azonosító → true, ha a kosárba tétel nem sikerült (pl. elfogyott)
  var egyreSikertelen = {};        // küszöb-azonosító → true, ha a dupla ajándék 1-re állítása nem sikerült
  var elozoElert = null;   // az előző rajzoláskor elért küszöbök azonosítói
  var frissUzenet = null;  // {id, lejar}: frissen elért küszöb üzenete pár másodpercig
  var betoltve = false;

  /* ---------- segédek ---------- */

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function penz(cent, format) {
    // a téma _formatMoney logikája (component-shipping-notice.js) rövidítve
    var f = format || '{{amount}}';
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/);
    var tipus = m ? m[1] : 'amount';
    function fmt(n, prec, ezres, tized) {
      n = (Math.abs(n) / 100).toFixed(prec);
      var r = n.split('.');
      var e = r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + ezres);
      return e + (r[1] ? tized + r[1] : '');
    }
    var v;
    switch (tipus) {
      case 'amount_no_decimals': v = fmt(cent, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = fmt(cent, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cent, 0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': v = fmt(cent, 0, ' ', ','); break;
      case 'amount_with_space_separator': v = fmt(cent, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cent, 2, "'", '.'); break;
      default: v = fmt(cent, 2, ',', '.');
    }
    return f.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  function helyettesit(szoveg, hianyzo, kuszob) {
    return esc(szoveg)
      .replace(/\[(suma|összeg|osszeg|amount)\]/gi, '<b>' + esc(penz(hianyzo, cfg.penzFormatum)) + '</b>')
      .replace(/\[(küszöb|kuszob|prah|threshold)\]/gi, '<b>' + esc(penz(kuszob, cfg.penzFormatum)) + '</b>');
  }

  function kuszobFelirat(cent) {
    return esc(cfg.kuszobFormatum).replace(/\[(suma|összeg|osszeg|amount)\]/gi, esc(penz(cent, cfg.penzFormatum)));
  }

  function kosarErtek() {
    // az automatikusan betett ajándék sorai nem számítanak bele (különben a saját ára tolná a küszöb fölé)
    var ajandek = 0;
    Object.keys(kosar.ajandekSorok || {}).forEach(function (id) {
      var s = kosar.ajandekSorok[id];
      ajandek += cfg.osszegAlap === 'reszosszeg' ? (s.eredeti || 0) : (s.vegar || 0);
    });
    var alap = cfg.osszegAlap === 'reszosszeg' ? kosar.subtotal : kosar.total;
    return Math.max(0, alap - ajandek);
  }

  /* ---------- ajándék automatikusan a kosárba ---------- */

  // Egy ajándékhoz több kosársor is tartozhat: a Shopify a „Buy X get Y” kedvezménynél kettéosztja a sort,
  // ha nem az egész mennyiség ingyenes. Ezért sor-kulcsonként gyűjtünk, az árakat összesítjük.
  function ajandekSorokGyujt(c) {
    var sorok = {};
    (c.items || []).forEach(function (t) {
      var id = t.properties && t.properties._lgd_ajandek;
      if (!id) return;
      if (!sorok[id]) sorok[id] = { key: t.key, kulcsok: [], darab: 0, vegar: 0, eredeti: 0 };
      sorok[id].kulcsok.push(t.key);
      sorok[id].darab += t.quantity || 0;
      sorok[id].vegar += t.final_line_price || 0;
      sorok[id].eredeti += t.original_line_price || 0;
    });
    return sorok;
  }

  // az ajándék sorain a kosárban nincs mennyiség-választó (mindig 1 db), csak felirat és „Eltávolítás”
  function ajandekSorokZarol() {
    if (!cfg) return;
    var kulcsok = [];
    Object.keys(kosar.ajandekSorok || {}).forEach(function (id) {
      var s = kosar.ajandekSorok[id];
      (s.kulcsok || [s.key]).forEach(function (k) { kulcsok.push(k); });
    });
    var tetelek = document.querySelectorAll('[data-js-cart-item][data-id]');
    for (var i = 0; i < tetelek.length; i++) {
      var t = tetelek[i];
      var ajandek = kulcsok.indexOf(t.getAttribute('data-id')) >= 0;
      t.setAttribute('data-lgd-nezve', '1');
      if (ajandek && !t.classList.contains('lgd-ajandek-sor')) {
        t.classList.add('lgd-ajandek-sor');
        var valaszto = t.querySelector('product-quantity, .quantity-selector-holder');
        if (valaszto && cfg.sav.ajandekSorFelirat) {
          var cimke = document.createElement('span');
          cimke.className = 'lgd-ajandek-sor__cimke';
          cimke.textContent = cfg.sav.ajandekSorFelirat;
          valaszto.parentNode.insertBefore(cimke, valaszto);
        }
      } else if (!ajandek && t.classList.contains('lgd-ajandek-sor')) {
        t.classList.remove('lgd-ajandek-sor');
        var regi = t.querySelector('.lgd-ajandek-sor__cimke');
        if (regi) regi.parentNode.removeChild(regi);
      }
    }
  }

  function lemondva(id, beallit) {
    try {
      if (beallit) sessionStorage.setItem('lgd_ajandek_lemondva_' + id, '1');
      return sessionStorage.getItem('lgd_ajandek_lemondva_' + id) === '1';
    } catch (e) { return false; }
  }

  function kosarUtvonal() {
    return (window.KROWN && KROWN.settings && KROWN.settings.routes && KROWN.settings.routes.cart_url) || '/cart';
  }

  // a téma kosár-fiókjának / kosároldalának újrarenderelése (mint a téma refreshCart-ja, de a fiókot nem nyitja ki)
  function kosarUjrarajzol() {
    return fetch('?section_id=helper-cart')
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        var ujForm = html.getElementById('AjaxCartForm');
        var form = document.getElementById('AjaxCartForm');
        if (ujForm && form) {
          form.innerHTML = ujForm.innerHTML;
          if (typeof form.ajaxifyCartItems === 'function') form.ajaxifyCartItems();
          var db = form.querySelector('[data-cart-count]');
          var ossz = form.querySelector('[data-cart-total]');
          if (db) Array.prototype.forEach.call(document.querySelectorAll('[data-header-cart-count]'), function (e) { e.textContent = db.textContent; });
          if (ossz) Array.prototype.forEach.call(document.querySelectorAll('[data-header-cart-total]'), function (e) { e.textContent = ossz.textContent; });
        }
        var ujSub = html.getElementById('AjaxCartSubtotal');
        var sub = document.getElementById('AjaxCartSubtotal');
        if (ujSub && sub) sub.innerHTML = ujSub.innerHTML;
      })
      .catch(function () {});
  }

  function ajandekSzinkron() {
    if (!cfg || !cfg.aktiv || ajandekFolyamatban) return;
    var ertek = kosarErtek();
    var muvelet = null;
    rendezettKuszobok().some(function (k) {
      if (!k.ajandekVariant) return false;
      var sor = kosar.ajandekSorok[k.id];
      var elert = ertek >= k.cent && kosar.darab > 0;
      if (elert && !sor && k.ajandekElerheto && !lemondva(k.id) && !ajandekSikertelen[k.id]) {
        muvelet = { tipus: 'be', k: k };
      } else if (!elert && sor) {
        muvelet = { tipus: 'ki', k: k, sor: sor };
      } else if (elert && sor && sor.darab > 1 && !egyreSikertelen[k.id]) {
        // két oldal egyszerre tette be (pl. kosárba tétel után azonnali oldalváltás, vagy két fül): 1 marad,
        // különben a második darab teljes áron kerülne a kosárba
        muvelet = { tipus: 'egy', k: k, sor: sor };
      }
      return !!muvelet;
    });
    if (!muvelet) return;
    ajandekFolyamatban = true;
    var url, body;
    if (muvelet.tipus === 'be') {
      url = kosarUtvonal() + '/add.js';
      var prop = {}; prop._lgd_ajandek = muvelet.k.id;
      body = { items: [{ id: muvelet.k.ajandekVariant, quantity: 1, properties: prop }] };
    } else {
      url = kosarUtvonal() + '/update.js';
      var updates = {};
      (muvelet.sor.kulcsok || [muvelet.sor.key]).forEach(function (k, i) { updates[k] = (muvelet.tipus === 'egy' && i === 0) ? 1 : 0; });
      body = { updates: updates };
    }
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) {
        if (!r.ok && muvelet.tipus === 'be') ajandekSikertelen[muvelet.k.id] = true;
        if (!r.ok && muvelet.tipus === 'egy') egyreSikertelen[muvelet.k.id] = true;
        return kosarUjrarajzol();
      })
      .catch(function () {
        if (muvelet.tipus === 'be') ajandekSikertelen[muvelet.k.id] = true;
        if (muvelet.tipus === 'egy') egyreSikertelen[muvelet.k.id] = true;
      })
      .then(function () { ajandekFolyamatban = false; kosarFrissit(); });
  }

  function rendezettKuszobok() {
    return cfg.kuszobok.filter(function (k) { return k.cent > 0; })
      .sort(function (a, b) { return a.cent - b.cent; });
  }

  function ikon(nev) { return IKONOK[nev] || IKONOK.ajandek; }

  /* ---------- haladássáv ---------- */

  function savHtml(tipus) {
    var kuszobok = rendezettKuszobok();
    if (!kuszobok.length) return '';
    var ertek = kosarErtek();
    var n = kuszobok.length;
    // a küszöbök egyenletesen, a szakaszok közepén ülnek (mint a BOGOS-nál): 1 küszöb → 50%, 2 → 25% és 75%.
    // Így az utolsó küszöb után is marad csík; ha minden elérve, a kitöltés a végéig ér. A kitöltés szakaszonként arányos.
    function pozicio(i) { return (i + 0.5) / n * 100; }
    var szazalek = 100;
    for (var i = 0; i < n; i++) {
      var also = i === 0 ? 0 : kuszobok[i - 1].cent;
      var alsoPoz = i === 0 ? 0 : pozicio(i - 1);
      if (ertek >= kuszobok[i].cent) continue;
      szazalek = alsoPoz + (ertek - also) / (kuszobok[i].cent - also) * (pozicio(i) - alsoPoz);
      break;
    }
    szazalek = Math.max(0, Math.min(100, szazalek));
    var kovetkezo = null;
    var utolsoElert = null;
    kuszobok.forEach(function (k) {
      if (ertek >= k.cent) utolsoElert = k;
      else if (!kovetkezo) kovetkezo = k;
    });

    var uzenet, uzenetElert = false;
    if (frissUzenet && Date.now() < frissUzenet.lejar) {
      var fk = kuszobok.filter(function (k) { return k.id === frissUzenet.id; })[0];
      if (fk) { uzenet = helyettesit(fk.utana, 0, fk.cent); uzenetElert = true; }
    }
    if (!uzenet) {
      if (kosar.darab === 0 || ertek <= 0) {
        uzenet = esc(cfg.sav.uresSzoveg);
      } else if (kovetkezo) {
        uzenet = helyettesit(kovetkezo.elotte, kovetkezo.cent - ertek, kovetkezo.cent);
      } else {
        uzenet = cfg.sav.keszSzoveg ? esc(cfg.sav.keszSzoveg) : helyettesit(utolsoElert.utana, 0, utolsoElert.cent);
        uzenetElert = true;
      }
    }

    var celok = '', pontok = '';
    kuszobok.forEach(function (k, i) {
      var poz = pozicio(i);
      var elert = ertek >= k.cent;
      // a feliratok rácsban ülnek (n egyenlő oszlop), így a pontok fölé esnek és több sorba is törhetnek
      celok += '<div class="lgd-asav__cel' + (elert ? ' lgd-asav__cel--elert' : '') + '">' +
        '<span class="lgd-asav__cel-nev">' + esc(k.nev) + '</span>' +
        '<span class="lgd-asav__cel-osszeg">' + kuszobFelirat(k.cent) + '</span></div>';
      var most = elozoElert && elert && elozoElert.indexOf(k.id) < 0;
      pontok += '<span class="lgd-asav__pont' + (elert ? ' lgd-asav__pont--elert' : '') + (most ? ' lgd-asav__pont--most' : '') +
        '" style="left:' + poz.toFixed(2) + '%" title="' + esc(k.nev) + '">' + ikon(k.ikon) + '</span>';
    });
    // a kitöltés végén egy kis jelölő mutatja, hol tart a kosár (mint a BOGOS-nál)
    var jelolo = kosar.darab > 0 && ertek > 0 ? '<span class="lgd-asav__jelolo" style="left:' + szazalek.toFixed(2) + '%"></span>' : '';

    return '<div class="lgd-asav lgd-asav--' + tipus + (cfg.sav.keret ? ' lgd-asav--keret' : '') + '" role="status" aria-live="polite">' +
      (cfg.sav.cim && tipus !== 'panel' ? '<span class="lgd-asav__cim">' + esc(cfg.sav.cim) + '</span>' : '') +
      '<span class="lgd-asav__uzenet' + (uzenetElert ? ' lgd-asav__uzenet--elert' : '') + '">' + uzenet + '</span>' +
      '<div class="lgd-asav__celok' + (n >= 4 ? ' lgd-asav__celok--sok' : '') + '" style="grid-template-columns:repeat(' + n + ',1fr)">' + celok + '</div>' +
      '<div class="lgd-asav__csik"><div class="lgd-asav__kitoltes" style="width:' + szazalek.toFixed(2) + '%"></div>' + pontok + jelolo + '</div>' +
      '</div>';
  }

  function savokRajzol() {
    var pontok = document.querySelectorAll('[data-lgd-akciosav]');
    for (var i = 0; i < pontok.length; i++) {
      var p = pontok[i];
      var tipus = p.getAttribute('data-lgd-akciosav');
      var mutat = (tipus === 'fiok' && cfg.sav.fiok) || (tipus === 'oldal' && cfg.sav.oldal) || tipus === 'panel';
      if (mutat && tipus !== 'panel' && kosar.darab === 0 && !cfg.sav.uresnel) mutat = false;
      var html = mutat ? savHtml(tipus) : '';
      p.setAttribute('data-lgd-kesz', '1');
      if (p.innerHTML !== html) {
        // első rajzolásnál a kitöltés 0-ról animálódik a tényleges értékre
        var elsoRajz = p.innerHTML === '';
        p.innerHTML = html;
        if (elsoRajz && html) elsoAnimacio(p);
      }
    }
  }

  // első rajzolásnál a kitöltés 0-ról animálódik a tényleges értékre.
  // Külön függvény, hogy minden sávnak a SAJÁT csíkja kapja meg az értékét (ciklusban a késleltetett
  // visszahívás az utolsó sáv elemeit látta volna, és a többi 0%-on ragadt). setTimeout, nem
  // requestAnimationFrame: háttérlapon a rAF nem fut le.
  function elsoAnimacio(p) {
    var kit = p.querySelector('.lgd-asav__kitoltes');
    var jel = p.querySelector('.lgd-asav__jelolo');
    if (!kit) return;
    var cel = kit.style.width;
    kit.style.width = '0%';
    if (jel) jel.style.left = '0%';
    setTimeout(function () {
      kit.style.width = cel;
      if (jel) jel.style.left = cel;
    }, 40);
  }

  /* ---------- widget ---------- */

  function listaRajzol() {
    var lista = document.querySelector('[data-lgd-aw-lista]');
    if (!lista) return;
    var ertek = kosarErtek();
    var html = '';
    rendezettKuszobok().forEach(function (k) {
      var elert = ertek >= k.cent;
      html += '<div class="lgd-awidget__tetel' + (elert ? ' lgd-awidget__tetel--elert' : '') + '">' +
        '<div class="lgd-awidget__tetel-kep">' + (k.kep ? '<img src="' + esc(k.kep) + '" alt="" loading="lazy">' : ikon(k.ikon)) + '</div>' +
        '<div class="lgd-awidget__tetel-szoveg">' +
        '<span class="lgd-awidget__tetel-nev">' + esc(k.nev) + '</span>' +
        '<span class="lgd-awidget__tetel-osszeg">' + kuszobFelirat(k.cent) + '</span>' +
        (k.leiras ? '<span class="lgd-awidget__tetel-leiras">' + esc(k.leiras) + '</span>' : '') +
        '<span class="lgd-awidget__tetel-allapot">' + (elert ? '✓ ' + helyettesit(k.utana, 0, k.cent) : helyettesit(k.elotte, k.cent - ertek, k.cent)) + '</span>' +
        (k.link ? '<a class="lgd-awidget__tetel-gomb" href="' + esc(k.link) + '">' + esc(cfg.widget.gombFelirat || '→') + '</a>' : '') +
        '</div></div>';
    });
    if (lista.innerHTML !== html) lista.innerHTML = html;

    var jelveny = document.querySelector('[data-lgd-aw-jelveny]');
    if (jelveny) {
      var hatra = rendezettKuszobok().filter(function (k) { return ertek < k.cent; }).length;
      if (hatra > 0) { jelveny.textContent = String(hatra); jelveny.hidden = false; }
      else if (rendezettKuszobok().length) { jelveny.textContent = '✓'; jelveny.hidden = false; }
      else jelveny.hidden = true;
    }
  }

  function panelNyit(nyit) {
    var w = document.querySelector('[data-lgd-awidget]');
    if (!w) return;
    var panel = w.querySelector('[data-lgd-aw-panel]');
    var gomb = w.querySelector('[data-lgd-aw-gomb]');
    if (nyit === undefined) nyit = panel.hidden;
    gomb.setAttribute('aria-expanded', nyit ? 'true' : 'false');
    w.classList.toggle('lgd-awidget--nyitva', nyit);
    clearTimeout(panel.__lgdZar);
    if (nyit) {
      panel.hidden = false;
      setTimeout(function () { panel.classList.add('lgd-awidget__panel--nyitva'); }, 20);
    } else {
      panel.classList.remove('lgd-awidget__panel--nyitva');
      panel.__lgdZar = setTimeout(function () { panel.hidden = true; }, 230);
    }
  }

  /* ---------- igazítás a chat (Shopify Inbox) gombjához ---------- */

  function chatGomb() {
    var el = document.querySelector('shopify-chat');
    if (!el || !el.shadowRoot) return null;
    return el.shadowRoot.querySelector('.activator') || el.shadowRoot.querySelector('button');
  }

  // a widget a chat gombjának méretét, jobb szélét és lekerekítését veszi át, és alá vagy fölé ül
  function chatIgazit() {
    var w = document.querySelector('[data-lgd-awidget]');
    if (!w || !cfg || !cfg.widget || cfg.widget.chathoz === 'nincs') return false;
    var g = chatGomb();
    if (!g) return false;
    var r = g.getBoundingClientRect();
    if (!r.width || !r.height) return false;
    var vw = document.documentElement.clientWidth;
    var vh = window.innerHeight;
    var meret = Math.round(r.height);
    var hezag = 12;
    var alulChat = Math.round(vh - r.bottom);  // a chat gombjának távolsága alulról
    var alul = cfg.widget.chathoz === 'felett' ? alulChat + meret + hezag : Math.max(6, alulChat - meret - hezag);
    w.style.setProperty('--lgd-aw-meret', meret + 'px');
    w.style.setProperty('--lgd-aw-alul', alul + 'px');
    w.style.setProperty('--lgd-aw-sarok', getComputedStyle(g).borderRadius || '999px');
    if (w.classList.contains('lgd-awidget--bal')) w.style.setProperty('--lgd-aw-oldalt', Math.round(r.left) + 'px');
    else w.style.setProperty('--lgd-aw-oldalt', Math.round(vw - r.right) + 'px');
    return true;
  }

  function chatFigyel() {
    if (window.__lgdChatFigyel) return;
    window.__lgdChatFigyel = true;
    var probak = 0;
    var idozito = setInterval(function () {
      probak++;
      if (chatIgazit() || probak > 60) clearInterval(idozito);  // max. 30 mp-ig várjuk a chat betöltését
    }, 500);
    window.addEventListener('resize', function () { chatIgazit(); });
    window.addEventListener('orientationchange', function () { setTimeout(chatIgazit, 300); });
  }

  function widgetEsemenyek() {
    var w = document.querySelector('[data-lgd-awidget]');
    if (!w || w.__lgdKesz) return;
    w.__lgdKesz = true;
    chatIgazit();
    chatFigyel();
    w.querySelector('[data-lgd-aw-gomb]').addEventListener('click', function () { panelNyit(); });
    w.querySelector('[data-lgd-aw-bezar]').addEventListener('click', function () { panelNyit(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') panelNyit(false); });
    document.addEventListener('click', function (e) {
      if (!w.contains(e.target)) panelNyit(false);
    });
  }

  /* ---------- közös rajzolás, kosár-frissítés ---------- */

  function rajzol() {
    if (!cfg) return;
    savokRajzol();
    listaRajzol();
    widgetEsemenyek();
    var ertek = kosarErtek();
    elozoElert = rendezettKuszobok().filter(function (k) { return ertek >= k.cent; }).map(function (k) { return k.id; });
    ajandekSorokZarol();
  }

  function kosarBeallit(c) {
    var ujTotal = Number(c.total_price) || 0;
    var regiErtek = kosarErtek();
    var regiSorok = kosar.ajandekSorok || {};
    kosar = { total: ujTotal, subtotal: Number(c.items_subtotal_price) || 0, darab: Number(c.item_count) || 0, ajandekSorok: ajandekSorokGyujt(c) };
    var ujErtek = kosarErtek();
    if (ujErtek < regiErtek) frissUzenet = null; // csökkenő kosárnál a „frissen elérve” üzenet nem marad
    // ha az ajándék sora eltűnt, pedig a küszöb még elérve, és nem mi vettük ki: a vevő mondta le → ebben a látogatásban nem tesszük vissza
    if (!ajandekFolyamatban) {
      rendezettKuszobok().forEach(function (k) {
        if (k.ajandekVariant && regiSorok[k.id] && !kosar.ajandekSorok[k.id] && ujErtek >= k.cent) lemondva(k.id, true);
      });
    }
    // frissen elért küszöb: pár másodpercig az „elérve” szöveg látszik
    if (ujErtek > regiErtek) {
      var friss = rendezettKuszobok().filter(function (k) { return regiErtek < k.cent && ujErtek >= k.cent; });
      if (friss.length) {
        frissUzenet = { id: friss[friss.length - 1].id, lejar: Date.now() + 4000 };
        setTimeout(function () { frissUzenet = null; rajzol(); }, 4200);
      }
    }
    rajzol();
    ajandekSzinkron();
  }

  var frissitesIdozito = null;
  function kosarFrissit() {
    clearTimeout(frissitesIdozito);
    frissitesIdozito = setTimeout(function () {
      var url = ((window.KROWN && KROWN.settings && KROWN.settings.routes && KROWN.settings.routes.cart_url) || '/cart') + '.js';
      fetch(url, { cache: 'no-store', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(kosarBeallit)
        .catch(function () {});
    }, 150);
  }

  function kosarHivas(url) {
    return typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url);
  }

  function figyelok() {
    if (window.__lgdAkcioSavFigyel) return;
    window.__lgdAkcioSavFigyel = true;

    // fetch-hívások a kosárhoz (téma, ajánló, appok)
    var eredetiFetch = window.fetch;
    window.fetch = function (bemenet, opciok) {
      var url = typeof bemenet === 'string' ? bemenet : (bemenet && bemenet.url);
      var p = eredetiFetch.apply(this, arguments);
      if (kosarHivas(url)) p.then(function () { kosarFrissit(); }, function () {});
      return p;
    };
    // XMLHttpRequest-alapú appok
    var eredetiOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (metodus, url) {
      if (kosarHivas(url)) this.addEventListener('loadend', function () { kosarFrissit(); });
      return eredetiOpen.apply(this, arguments);
    };
    // a téma saját eseményei
    document.addEventListener('cart-updated', kosarFrissit, true);
    document.addEventListener('cart:refresh', kosarFrissit, true);
    // a kosár-fiók újrarenderelése után a beépítési pont üresen jön vissza → újrarajzolás
    new MutationObserver(function () {
      if (!cfg) return;
      if (document.querySelector('[data-lgd-akciosav]:not([data-lgd-kesz])')) rajzol();
      if (document.querySelector('[data-js-cart-item]:not([data-lgd-nezve])')) ajandekSorokZarol();
    }).observe(document.body, { childList: true, subtree: true });

    // téma-szerkesztő
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector('[data-lgd-akciosav-config]')) { elozoElert = null; betolt(); }
    });
    document.addEventListener('shopify:section:select', function (e) {
      if (e.target && e.target.querySelector('[data-lgd-akciosav-config]')) panelNyit(true);
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      if (e.target && e.target.querySelector('[data-lgd-akciosav-config]')) panelNyit(false);
    });
  }

  function betolt() {
    var el = document.querySelector('[data-lgd-akciosav-config]');
    if (!el) { cfg = null; return; }
    try { cfg = JSON.parse(el.textContent); } catch (e) { cfg = null; return; }
    var elsoBetoltes = !betoltve;
    if (!betoltve) {
      kosar = { total: cfg.kosar.total, subtotal: cfg.kosar.subtotal, darab: cfg.kosar.darab, ajandekSorok: cfg.kosar.ajandekSorok || {} };
      betoltve = true;
    }
    rajzol();
    ajandekSzinkron();
    // ajándékos kosárnál betöltéskor egyszer frissen is beolvassuk a kosarat: a fenti állapot az oldal
    // generálásakori, és a dupla ajándék sorait (azonos azonosító) nem tudja összeadni
    if (elsoBetoltes && Object.keys(kosar.ajandekSorok).length) kosarFrissit();
  }

  function indit() {
    figyelok();
    betolt();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', indit);
  else indit();
})();
